// removed by extract-text-webpack-plugin
module.exports = {"medium":"(min-width:768px)","large":"(min-width:1200px)","grid":"tabletlandscape__grid___oZoBE","gridItem":"tabletlandscape__gridItem___XwNnt","device":"tabletlandscape__device___3ZCeR","deviceContent":"tabletlandscape__deviceContent___i_UPt","deviceScreen":"tabletlandscape__deviceScreen___3oB5l","img":"tabletlandscape__img___1GKBy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TabletLandscape/tabletlandscape.css
// module id = 167
// module chunks = 0